module.exports = __webpack_public_path__ + "static/img/usBottom3.b8f2340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/usBottom3.png
// module id = HNgS
// module chunks = 2